const enum NotificationStatus {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  DANGER = 'DANGER',
  CLIENT_NOTIFICATION = 'CLIENT_NOTIFICATION',
}

export default NotificationStatus;
